"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if a value matches ("===") the comparison.
 *
 * @export
 * @class IsEqualValidator
 * @implements {PropertyValidator<T>}
 * @template T
 */
class IsEqualValidator {
    constructor(comparison) {
        this.comparison = comparison;
    }
    isValid(input) {
        return this.comparison === input;
    }
}
exports.IsEqualValidator = IsEqualValidator;
//# sourceMappingURL=IsEqualValidator.js.map